import { render } from "./MonitoreoInterno.vue?vue&type=template&id=d9f9cb24&scoped=true"
import script from "./MonitoreoInterno.vue?vue&type=script&lang=js"
export * from "./MonitoreoInterno.vue?vue&type=script&lang=js"

import "./MonitoreoInterno.vue?vue&type=style&index=0&id=d9f9cb24&lang=scss&scoped=true"

import exportComponent from "/proyectos/programas-de-investigacion/cah-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9f9cb24"]])

export default __exports__